import { UIPortal } from "@solidwhite/ui-portal";
import SideBar from "@ui/SideBar/SideBar";
import { MountWithEbbne, useEbbne } from "@solidwhite/ebbnen";
import { GreenGrid } from "../../effects/GreenGrid";
import React, { Suspense, useEffect, useState } from "react";
import { MarkerLabels } from "@ui/MarkerLabel";
import { findObjectStartsWithKey, getUrl, useDracoGLTF } from "@utils";
import VisibleWithEbbne from "../../VisibleWithEbbne";
import SetCameraTarget from "../../SetCameraTarget";
import LoadingCallback from "../../../LoadingCallback";

import useAuth from "../../../../hooks/useAuth";

export const WeldacInterior = () => {
  const { currentUser } = useAuth();
  const [model, setModel] = useState<string | null>(null);

  useEffect(() => {
    if (currentUser !== null) {
      getUrl({
        path: `${import.meta.env.MODE === "electron" ? "" : "public/"}authenticated/models/Weldac_Interior.glb`,
      })
        .then((result) => {
          if (result instanceof Error) return;
          setModel(result.url.toString());
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setModel(null);
    }
  }, [currentUser]);

  if (!model) return null;

  return (
    <Suspense fallback={<LoadingCallback />}>
      <WeldacInteriorModel model={model} />
    </Suspense>
  );
};

const WeldacInteriorModel = ({ model }: { model: string }) => {
  const { ebbneId } = useEbbne();

  const Weldac_Interior = useDracoGLTF(model);
  const markers_weldac_interior = findObjectStartsWithKey("markers_weldac_interior", Weldac_Interior.scene);
  const cameraTarget = findObjectStartsWithKey("CameraTarget", Weldac_Interior.scene);

  return (
    <>
      <MountWithEbbne>
        {cameraTarget && <SetCameraTarget settingsObject={cameraTarget} />}

        <GreenGrid position={[0, -0.02, 0]} cellSize={0.4} sectionSize={2} fadeDistance={50} fadeStrength={5} />
        <MarkerLabels node={markers_weldac_interior}></MarkerLabels>
        <UIPortal>
          <SideBar key={`Sidebar_${ebbneId}`} contentId={"weldac-interior"} />
        </UIPortal>
      </MountWithEbbne>

      <VisibleWithEbbne visibleWhen={"visible"}>
        <primitive object={Weldac_Interior.scene}></primitive>
      </VisibleWithEbbne>
    </>
  );
};
